<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <imports-list :context="{ teamId: props.teamId }" importType="conversion" :readOnly="true">
                <template v-slot:title>Conversion Imports</template>
            </imports-list>
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import ImportsList from '~/components/import/ImportsList.vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});
</script>
